import { createContext } from 'react';
import TeamsStore from '.';

export const TeamsStoreContext = createContext(new TeamsStore());
